import React from "react";
import PageTitle from "../atoms/PageTitle";
import StoreList from "../organisms/StoreList";

const StorePage: React.FC = () => {

    return (
        <>
            <PageTitle text="店舗管理" />
            <StoreList />
        </>
    )
}

export default StorePage